export default __webpack_public_path__ + "static/media/octasmart.4b9a3968.jpg";